import { createAction, props } from '@ngrx/store';
import { Organization } from '@shared/types/organization.model';

export const loadOrganizations = createAction('[Organization] Load Organizations');

export const loadOrganizationsSuccess = createAction(
  '[Organization] Load Organizations Success',
  props<{ organizations: Organization[] }>()
);

export const loadOrganizationsFailure = createAction(
  '[Organization] Load Organizations Failure',
  props<{ error: string }>()
);

export const selectOrganization = createAction(
  '[Organization] Select Organization',
  props<{ organizationId: string | null }>()
);

export const clearOrganizationState = createAction('[Organization] Clear Organization State');
